// extracted by mini-css-extract-plugin
export var container = "MenuBar-module--container--9197e";
export var core = "MenuBar-module--core--f554e";
export var hamburger = "MenuBar-module--hamburger--7479c";
export var links = "MenuBar-module--links--c8c56";
export var nav = "MenuBar-module--nav--5b514";
export var open = "MenuBar-module--open--03846";
export var socials = "MenuBar-module--socials--cb454";
export var transparent = "MenuBar-module--transparent--38f6d";
export var whatsapp = "MenuBar-module--whatsapp--1b486";